// Fragment "media (lot C)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    "media.libraryTitle": "Médiathèque",
    "media.picker.hint": "Choisissez une image ou importez un nouveau fichier.",
    "media.picker.upload": "Importer une photo",
    "media.picker.uploading": "Import en cours…",
    "media.picker.loading": "Chargement de la médiathèque…",
    "media.picker.empty": "Aucune image dans votre médiathèque. Importez une photo ci-dessus pour commencer.",
    "media.picker.select": "Choisir",
    "media.picker.cancel": "Annuler",
    "media.picker.loadFailed": "La médiathèque n'a pas pu être chargée.",
    "media.picker.uploadFailed": "L'import a échoué.",
    "media.subtitle": "Téléversez des images et des vidéos à utiliser dans vos cours, produits, articles ou sur le site.",
    "media.dropzone.text": "Glissez un fichier (image ou vidéo) ou choisissez-en un.",
    "media.dropzone.limits": "Images jusqu'à 25 Mo · Vidéos jusqu'à 250 Mo (upload accéléré par morceaux)",
    "media.upload": "Téléverser",
    "media.uploading": "Téléversement… {n}%",
    "media.file": "Fichier",
    "media.import.title": "Importer depuis Google Drive ou un lien",
    "media.import.subtitle": "Connectez votre Google Drive pour choisir un fichier, ou collez une URL d'image/vidéo directe.",
    "media.import.drivePick": "Choisir dans Google Drive",
    "media.import.driveLoading": "Chargement de Google…",
    "media.import.placeholder": "https://drive.google.com/file/d/…/view  (ou URL directe)",
    "media.import.submit": "Importer le lien",
    "media.toast.driveImported": "{name} importé depuis Drive",
    "media.toast.driveImportFailed": "Échec de l'import Drive",
    "media.toast.driveConnectFailed": "Connexion Google Drive échouée",
    "media.toast.urlImported": "Fichier importé",
    "media.toast.urlImportFailed": "Échec de l'import",
    "media.toast.uploaded": "{name} téléversé",
    "media.toast.uploadFailed": "Échec du téléversement",
    "media.toast.deleted": "Supprimé",
    "media.confirm.delete": "Supprimer ce fichier ?",
    "media.copied": "Copié",
    "media.copyUrl": "URL",
    "media.size.mb": "{n} Mo",
    "media.size.kb": "{n} ko",

    "siteImages.subtitle": "Cliquez sur « Changer » pour remplacer une image. Les modifications sont visibles immédiatement sur le site public.",
    "siteImages.change": "Changer",
    "siteImages.reset": "Réinitialiser",
    "siteImages.custom": "Personnalisée",
    "siteImages.default": "Par défaut",
    "siteImages.toast.uploaded": "Image mise à jour",
    "siteImages.toast.reset": "Image réinitialisée",
    "siteImages.toast.failed": "Échec",
  },
  en: {
    "media.libraryTitle": "Media Library",
    "media.picker.hint": "Select an image or upload a new file.",
    "media.picker.upload": "Upload a photo",
    "media.picker.uploading": "Uploading…",
    "media.picker.loading": "Loading the media library…",
    "media.picker.empty": "No images in your media library yet. Upload a photo above to get started.",
    "media.picker.select": "Select",
    "media.picker.cancel": "Cancel",
    "media.picker.loadFailed": "The media library could not be loaded.",
    "media.picker.uploadFailed": "The upload failed.",
    "media.subtitle": "Upload images and videos to use in your courses, products, articles, or on your site.",
    "media.dropzone.text": "Drag a file (image or video) here or choose one.",
    "media.dropzone.limits": "Images up to 25 MB · Videos up to 250 MB (accelerated chunked upload)",
    "media.upload": "Upload",
    "media.uploading": "Uploading… {n}%",
    "media.file": "File",
    "media.import.title": "Import from Google Drive or a link",
    "media.import.subtitle": "Connect your Google Drive to pick a file, or paste a direct image/video URL.",
    "media.import.drivePick": "Choose from Google Drive",
    "media.import.driveLoading": "Loading Google…",
    "media.import.placeholder": "https://drive.google.com/file/d/…/view  (or direct URL)",
    "media.import.submit": "Import link",
    "media.toast.driveImported": "{name} imported from Drive",
    "media.toast.driveImportFailed": "Drive import failed",
    "media.toast.driveConnectFailed": "Google Drive connection failed",
    "media.toast.urlImported": "File imported",
    "media.toast.urlImportFailed": "Import failed",
    "media.toast.uploaded": "{name} uploaded",
    "media.toast.uploadFailed": "Upload failed",
    "media.toast.deleted": "Deleted",
    "media.confirm.delete": "Delete this file?",
    "media.copied": "Copied",
    "media.copyUrl": "URL",
    "media.size.mb": "{n} MB",
    "media.size.kb": "{n} KB",

    "siteImages.subtitle": 'Click "Change" to replace an image. Changes appear immediately on the public site.',
    "siteImages.change": "Change",
    "siteImages.reset": "Reset",
    "siteImages.custom": "Custom",
    "siteImages.default": "Default",
    "siteImages.toast.uploaded": "Image updated",
    "siteImages.toast.reset": "Image reset",
    "siteImages.toast.failed": "Failed",
  },
  es: {
    "media.libraryTitle": "Biblioteca de medios",
    "media.picker.hint": "Elige una imagen o sube un archivo nuevo.",
    "media.picker.upload": "Subir una foto",
    "media.picker.uploading": "Subiendo…",
    "media.picker.loading": "Cargando la biblioteca de medios…",
    "media.picker.empty": "Aún no hay imágenes en tu biblioteca. Sube una foto arriba para empezar.",
    "media.picker.select": "Elegir",
    "media.picker.cancel": "Cancelar",
    "media.picker.loadFailed": "No se pudo cargar la biblioteca de medios.",
    "media.picker.uploadFailed": "La subida falló.",
    "media.subtitle": "Sube imágenes y videos para usar en tus cursos, productos, artículos o en el sitio.",
    "media.dropzone.text": "Arrastra un archivo (imagen o video) o elige uno.",
    "media.dropzone.limits": "Imágenes hasta 25 MB · Videos hasta 250 MB (subida acelerada por fragmentos)",
    "media.upload": "Subir",
    "media.uploading": "Subiendo… {n}%",
    "media.file": "Archivo",
    "media.import.title": "Importar desde Google Drive o un enlace",
    "media.import.subtitle": "Conecta tu Google Drive para elegir un archivo, o pega una URL directa de imagen/video.",
    "media.import.drivePick": "Elegir desde Google Drive",
    "media.import.driveLoading": "Cargando Google…",
    "media.import.placeholder": "https://drive.google.com/file/d/…/view  (o URL directa)",
    "media.import.submit": "Importar enlace",
    "media.toast.driveImported": "{name} importado desde Drive",
    "media.toast.driveImportFailed": "Error al importar desde Drive",
    "media.toast.driveConnectFailed": "Conexión con Google Drive fallida",
    "media.toast.urlImported": "Archivo importado",
    "media.toast.urlImportFailed": "Error al importar",
    "media.toast.uploaded": "{name} subido",
    "media.toast.uploadFailed": "Error al subir",
    "media.toast.deleted": "Eliminado",
    "media.confirm.delete": "¿Eliminar este archivo?",
    "media.copied": "Copiado",
    "media.copyUrl": "URL",
    "media.size.mb": "{n} MB",
    "media.size.kb": "{n} KB",

    "siteImages.subtitle": 'Haz clic en "Cambiar" para reemplazar una imagen. Los cambios aparecen de inmediato en el sitio público.',
    "siteImages.change": "Cambiar",
    "siteImages.reset": "Restablecer",
    "siteImages.custom": "Personalizada",
    "siteImages.default": "Predeterminada",
    "siteImages.toast.uploaded": "Imagen actualizada",
    "siteImages.toast.reset": "Imagen restablecida",
    "siteImages.toast.failed": "Error",
  },
};
